import { render, staticRenderFns } from "./signature-pad.vue?vue&type=template&id=0f7cc8f2"
import script from "./signature-pad.vue?vue&type=script&lang=js"
export * from "./signature-pad.vue?vue&type=script&lang=js"
import style0 from "./signature-pad.vue?vue&type=style&index=0&id=0f7cc8f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports